export default __webpack_public_path__ + "static/media/triangle-atention.0764158c.svg";